import { FaRobot, FaClock, FaChartLine, FaTools, FaDollarSign, FaUsers } from 'react-icons/fa';

export const businessAutomationServiceData = {
  slug: 'business-automation',
  title: 'Business Process Automation Arizona | Workflow Automation Phoenix',
  metaDescription: 'Professional business automation services in Arizona. Streamline workflows, reduce costs, and boost efficiency for Phoenix and Scottsdale businesses. Free automation audit.',
  keywords: [
    'business automation Arizona',
    'process automation Phoenix',
    'workflow automation Arizona',
    'business efficiency Phoenix',
    'automation consultant Arizona',
    'digital transformation Phoenix',
    'process optimization Arizona',
    'automation solutions Phoenix'
  ],
  
  hero: {
    title: 'Automate Your Business Processes for Maximum Efficiency',
    subtitle: 'Transform repetitive tasks into automated workflows that save time, reduce errors, and let your team focus on what matters most.',
    stats: [
      { number: '75%', label: 'Time Savings' },
      { number: '$50K+', label: 'Annual Savings' },
      { number: '95%', label: 'Error Reduction' }
    ]
  },

  whyChooseUs: {
    title: 'Why Automate Your Business Processes',
    benefits: [
      {
        icon: <FaRobot />,
        title: 'Eliminate Manual Work',
        description: 'Transform repetitive, time-consuming tasks into efficient automated workflows that run 24/7 without supervision. Focus your team on strategic work while automation handles the routine tasks that drain productivity and morale.'
      },
      {
        icon: <FaClock />,
        title: 'Save Valuable Time',
        description: 'Free up 10-20 hours per week for your team to focus on strategic, revenue-generating activities. Every automated process compounds your time savings, creating exponential efficiency gains across your organization.'
      },
      {
        icon: <FaChartLine />,
        title: 'Boost Accuracy',
        description: 'Eliminate human errors with automated data entry, calculations, and process execution. Achieve 99%+ accuracy rates while maintaining consistency across all your business operations and customer interactions.'
      },
      {
        icon: <FaTools />,
        title: 'Scale Efficiently',
        description: 'Handle increased workload without hiring additional staff through smart automation solutions. Your systems grow with your business, processing more work seamlessly as you expand your operations.'
      },
      {
        icon: <FaDollarSign />,
        title: 'Reduce Operating Costs',
        description: 'Cut operational expenses by up to 60% through process automation. Most businesses recover their automation investment within 90 days and continue saving thousands monthly thereafter.'
      },
      {
        icon: <FaUsers />,
        title: 'Improve Team Satisfaction',
        description: 'Employees love automation because it eliminates tedious work and lets them focus on meaningful, creative tasks. Higher job satisfaction leads to better retention and increased productivity.'
      }
    ]
  },

  process: {
    title: 'Our Business Automation Process',
    description: 'A proven methodology that identifies opportunities and delivers measurable automation results.',
    steps: [
      {
        title: 'Process Audit & Discovery',
        description: 'Analyze your current workflows to identify the best automation opportunities and quantify potential savings.'
      },
      {
        title: 'Custom Automation Design',
        description: 'Design automated workflows tailored to your specific business needs using the right technology stack.'
      },
      {
        title: 'Implementation & Integration',
        description: 'Build and deploy automation solutions with seamless integration to your existing systems.'
      },
      {
        title: 'Training & Optimization',
        description: 'Train your team and continuously optimize automation for maximum efficiency and ROI.'
      }
    ]
  },

  technologies: {
    title: 'Automation Technologies We Use',
    items: [
      'Zapier Integration',
      'Microsoft Power Automate',
      'Google Apps Script',
      'Custom API Development',
      'Database Automation',
      'Email Marketing Automation',
      'Document Generation',
      'CRM Automation',
      'Inventory Management',
      'Report Automation',
      'Social Media Automation',
      'Lead Processing'
    ]
  },

  results: {
    title: 'Business Automation Results',
    items: [
      {
        metric: '75%',
        description: 'Reduction in manual data entry time'
      },
      {
        metric: '$50K+',
        description: 'Average annual cost savings'
      },
      {
        metric: '95%',
        description: 'Reduction in processing errors'
      },
      {
        metric: '40hrs',
        description: 'Average weekly time savings'
      }
    ]
  },

  faq: {
    title: 'Business Automation FAQ',
    items: [
      {
        question: 'What business processes can be automated?',
        answer: 'Most repetitive processes can be automated including data entry, report generation, customer communications, inventory updates, invoice processing, lead management, and appointment scheduling.'
      },
      {
        question: 'How quickly will I see ROI from automation?',
        answer: 'Most clients see positive ROI within 2-4 months. Time savings are immediate, and cost savings typically recover the investment within the first quarter.'
      },
      {
        question: 'Will automation replace my employees?',
        answer: 'No, automation enhances your team by eliminating tedious tasks, allowing them to focus on strategic, creative, and customer-facing activities that drive business growth.'
      },
      {
        question: 'Do you work with small businesses?',
        answer: 'Yes! We specialize in cost-effective automation solutions for small and medium businesses. Many simple automations can be implemented for under $5,000 with significant ongoing savings.'
      },
      {
        question: 'What if my current systems change?',
        answer: 'We build flexible automation solutions and provide ongoing support to adapt to system changes, software updates, and evolving business needs.'
      }
    ]
  },

  schema: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Business Process Automation Services",
    "description": "Professional business automation and workflow optimization for Arizona businesses",
    "provider": {
      "@type": "Person",
      "name": "Daniel Rangel",
      "telephone": "+1-480-282-0569",
      "email": "daniel@danielrayrangel.com"
    },
    "areaServed": {
      "@type": "State",
      "name": "Arizona"
    },
    "serviceType": "Business Automation",
    "offers": {
      "@type": "Offer",
      "description": "Custom business process automation and workflow optimization services"
    }
  }
};